<div [formGroup]="form" class="form-radio">
    <div class="radio-item" *ngFor="let item of radioItems">
        <label class="radiolabel">
            <div class="selector-name">
              <span [innerHTML]="item.label" (click)="select(item.value)"></span>
            </div>
            <input type="radio"
                [value]="item.value"
                [checked]="form.get(name).value == item.value"
                [formControlName]="name"
                (click)="select(item.value)"
            /><span class="radiomark"></span>
        </label>
    </div>
</div>
